<template>
  <el-dialog :visible.sync="visible" :show-close="false" width="fit-content" append-to-body @closed="$emit('closed')">
    <div
      class="reward-complete"
      :style="{
        'background-image': `url('${
          value
            ? require('@/assets/reward/reward-success-bgimg.png')
            : require('@/assets/reward/reward-faild-bgimg.png')
        }')`
      }"
    >
      <div class="content">
        <div class="warpper">
          <img
            class="emoji"
            :src="
              value
                ? require('@/assets/reward/reward-success-emoji.png')
                : require('@/assets/reward/reward-faild-emoji.png')
            "
            alt="赞赏成功"
          />
          <span class="txt">{{ value ? "赞赏成功！谢谢老板~" : "赞赏失败~老板请重试！" }}</span>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "RewardComplete",
  props: {
    /** true 赞赏成功，false 赞赏失败 */
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      visible: false
    };
  },
  mounted() {
    this.visible = true;
    setTimeout(() => {
      this.visible = false;
    }, 5000);
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
  background-color: transparent;
  box-shadow: none;
  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
}
.reward-complete {
  width: 252px;
  height: 215px;
  background-position: top center;
  background-size: 226px 78px;
  background-repeat: no-repeat;
  display: flex;
  align-items: flex-end;
  .content {
    width: 100%;
    height: 137px;
    border: 6px solid #a6bfc8;
    border-radius: 20px;
    background-color: #fff;
    .warpper {
      position: relative;
      top: -42px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .emoji {
        width: 108px;
        height: 111px;
        margin-bottom: 6px;
      }
      .txt {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
}
</style>
